<!-- 工作台 -->
<template>
    <div id="">
        <div class='star-list'>
            <div :key="index" class='star-item' v-for="(item,index) in star" @click='doStar(index)'>
                <img src='../../assets/images/star-active.png'
                     v-if="index < storeLocal"
                     :style="{width:size,height:size}">
                <img src='../../assets/images/star.png'
                     v-else-if="index >= storeLocal"
                     :style='{width:size,height:size}'>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: '',
        components: {

        },
        props:{
            store: {
                type: Number,
                default: 0
            },
            flag:{
                type:Object
            },
            // 是否可以操作评分
            canChange: {
                type: Boolean,
                default: true,
            },
            // 星星的大小
            size: {
                type: String,
                default: '24px'
            },
        },
        data(){
            return {
                star: [1, 1, 1, 1, 1],
                storeLocal:0,
            }
        },
        mounted(){
            this.storeLocal = this.store
        },
        methods:{
            doStar(index){
                if (!this.canChange) {
                    return
                }
                this.storeLocal = index + 1
                // 评分传给父组件
                this.$emit('getStore', index + 1,this.flag)
            },
        }
    }
</script>
<style lang="less" scoped>
    .star-list {
        width: inherit;
        display: flex;
        justify-content: space-between;
    }
    .star-item {
        cursor: pointer;
    }
</style>
